import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from '@/pages/Index'
import cooperation from '@/pages/cooperation'
import advertisement from '@/pages/advertisement'
Vue.use(VueRouter)

const router = new VueRouter({
  routes: [
    {
      path: '/Index',
      name: 'Index',
      component: Index,
      meta: {requireAuth: false}
    },
    {path: '*', redirect: '/Index'},
    {
      path: '/cooperation',
      name: 'cooperation',
      component: cooperation,
      meta: {requireAuth: false}
    },
    {
      path: '/advertisement',
      name: 'advertisement',
      component: advertisement,
      meta: {requireAuth: false}
    }
  ]
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js